<template>
	<v-card flat @click="viewLocumProfile(locum)">
		<v-list-item>
			<div>
				<v-list-item-avatar>
					<v-skeleton-loader v-if="!avatar" type="image" :loading="true" :width="40" :height="40"></v-skeleton-loader>
					<v-img v-if="avatar && avatar !== 'no_avatar'" :src="avatar"></v-img>
					<v-img v-if="avatar && avatar === 'no_avatar'" :src="no_avatar"></v-img>
				</v-list-item-avatar>
			</div>
			<v-list-item-content>
				<v-list-item-title class="subtitle-2 font-weight-black" v-text="locumName"></v-list-item-title>
				<v-list-item-subtitle class="secondary--text lighten-1 font-weight-bold" color="orange" v-text="locum.profession"></v-list-item-subtitle>
			</v-list-item-content>

			<v-list-item-avatar>
				<v-icon large color="secondary">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import store from '@/store';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { bus } from '@/main';

export default {
	name: 'LocumResultCard',
	props: {
		matchType: String,
		locum: Object,
	},
	data: () => ({
		avatar: null,
		no_avatar: require('@/assets/images/avatars/user.png'),
	}),
	computed: {
		...mapGetters('offers', ['offer']),

		locumName() {
			const { name, first_name = '', last_name = '' } = this.locum;
			return name ? name : `${first_name} ${last_name.charAt(0)}`;
		},

		getPracticeOffer() {
			return this.offer;
		},
	},
	mounted() {
		this.getAvatar();
	},
	methods: {
		...mapActions('availability', ['LoadAvailabilityByProfessionalForCompany']),

		...mapActions('bookings', ['LoadProfessionalBookings']),

		async getAvatar() {
			if (!this.avatar) {
				try {
					let response = await axios.get(store.getters.getDOCUMENTS + '/images/avatar/' + this.locum.id, { headers: { Authorization: store.getters.jwtToken } });
					this.avatar = 'data:image/png;base64,' + response.data.data;
				} catch (err) {
					this.avatar = 'no_avatar';
				}
			}
		},
		async viewLocumProfile(locum) {
			if (this.matchType === 'Partial') {
				this.checkPartialResultBookings(locum);
			} else {
				this.navigateToLocum(locum);
			}
		},
		navigateToLocum(locum) {
			store.dispatch('setPracticeLocumAvailabilitySlotSelected', [locum]);

			locum.source = `calendarDashboardSearch${this.matchType}`;
			store.dispatch('setPracticeViewingLocum', [locum]);

			bus.$emit('change-context', 'view-locum-details-card');
		},
		async checkPartialResultBookings(locum) {
			const { date, end_date, available_dates, request_dates } = this.getPracticeOffer; //store.getters.getPracticeOffer;
			const avails = await this.LoadAvailabilityByProfessionalForCompany({
				companyId: store.getters.company.id,
				professionalId: locum.id,
				start_date: date,
				end_date,
			});

			locum.request_dates = request_dates; // Adding request_dates to Locum object

			const bookings = await this.LoadProfessionalBookings({
				accountId: locum.id,
				startDate: date,
				endDate: end_date,
			});

			const allEvents = avails.concat(bookings);

			const datesArray = available_dates.reduce((datesArr, date) => {
				datesArr.push({ date, already_booked: false, status: 'Possibly Available' });
				return datesArr;
			}, []);

			const mappedDates = datesArray.map(availDate => {
				const matchingEvents = allEvents.filter(({ available_dates, booking_dates }) => {
					const datesArr = available_dates ? available_dates : booking_dates;
					if (!datesArr) {
						return false;
					}
					return datesArr.includes(availDate.date);
				});

				if (matchingEvents.length === 0) {
					return availDate;
				}

				let dateStatus = 'Possibly Available';
				let availability = { start_time: '', end_time: '' };
				let isBooked = false;

				for (const { status, start_time, end_time, id, available_dates = [] } of matchingEvents) {
					const { status: existingStatus } = availDate;
					if (status === 'confirmed') {
						dateStatus = 'Unavailable';
						isBooked = true;
					}
					if (status === 'unavailable' && existingStatus !== 'Unavailable') {
						dateStatus = 'Unavailable';
					}
					if ((status === 'open' || status === 'requested') && existingStatus !== 'Unavailable') {
						dateStatus = 'Available';
						availability = {
							id,
							date: available_dates[0],
							start_time,
							end_time,
						};
					}
					if (status === 'partially-confirmed' && existingStatus !== 'Unavailable') {
						dateStatus = 'Unavailable';
					}
				}

				availDate.status = dateStatus;
				availDate.already_booked = isBooked;
				if (availability.start_time && availability.end_time) {
					availDate.availability = availability;
				}

				return availDate;
			});

			locum.available_dates = mappedDates;

			this.navigateToLocum(locum);
		},
	},
};
</script>
